import React from 'react'
import { Card } from '@mui/material'
import { ShowBase as ReactAdminShowBase, CardContentInner, useTranslate } from 'react-admin'
import { ShowBaseProps } from './type'
import { ListActionsWithPermission } from '../ra-rbac'

const defaultListAction = {
  hasCreate: false,
  hasExport: false,
  hasPreview: false,
  hasEdit: true,
  hasShow: false,
  hasList: true,
}

const ShowBase: React.FC<ShowBaseProps> = ({
  children,
  title,
  listAction = {},
  noCard = false,
  ...props
}) => {
  const translate = useTranslate()
  return (
    <ReactAdminShowBase {...props}>
      <>
        <ListActionsWithPermission
          title={translate(title)}
          {...defaultListAction}
          {...listAction}
        />
        {!noCard ? (
          <Card>
            <CardContentInner>{children}</CardContentInner>
          </Card>
        ) : (
          children
        )}
      </>
    </ReactAdminShowBase>
  )
}

export default ShowBase
